<template>
  <div class="f-table-footer" :class="{ 'is-collapse': isCollapse }">
    <div v-if="checkbox" class="checkbox">
      <el-checkbox v-model="isCheckAll" :indeterminate="isIndeterminate" :disabled="tableTotalLength === 0" @change="onCheckAllChange" />
    </div>
    <div class="left">
      <slot />
    </div>
    <div class="right">
      <slot name="right" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'FTableFooter',
  props: {
    checkbox: {
      type: Boolean,
      default: false
    },

    list: {
			type: Array,
			default: () => [],
		},
		selection: {
			type: Array,
			default: () => [],
		},
  },
  data() {
    return {
      isCheckAll: false,
      isIndeterminate: false
    }
  },
  computed: {
    tableTotalLength () {
			return this.list.length
		},
		tableSelectionLength () {
			return this.selection.length
		},
    isCollapse() {
      return this.$store.state.commonStore.collapse
    },
  },
  watch: {
    tableSelectionLength () {
			this.isCheckAll =
				this.tableTotalLength === this.tableSelectionLength &&
				this.tableSelectionLength > 0;
			this.isIndeterminate =
				this.tableSelectionLength > 0 &&
				this.tableSelectionLength < this.tableTotalLength;
		},
  },
  methods: {
    onCheckAllChange (val) {
			this.$emit("toggle",val)
		},
  }
}
</script>

<style lang="scss" slot-scoped>
.f-table-footer {
  display: flex;
  align-items: center;
  padding: 13px 0;
  line-height: 28px;
  .checkbox {
    width: 40px;
    padding: 0 12px;
    display: inline-block;
  }
  .left {
    flex: auto;
  }
  .right {
    flex: none;
  }
}
</style>
